export const iconFontAwesomeHumanitarianUsersViewfinder = (
	<i className="fa-solid fa-users-viewfinder"></i>
);
